document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('form [name^=tx_form_formframework][type=submit]')?.closest('form')?.addEventListener('submit', () => {
        document.body.insertAdjacentHTML('beforeend','<div class="formSubmitLoaderBackground"><div class="loading-wheel"></div></div>')
    });

    // Replace link to privacy policy in checkbox labels
    const checkboxLabels = document.querySelectorAll('.form-check span') as NodeListOf<HTMLElement>;
    checkboxLabels.forEach(checkboxLabel => {
        checkboxLabel.innerHTML = checkboxLabel.innerHTML.replace(/Datenschutzerklärung/g, '<a id="termslink" href="/de/datenschutzerklaerung" target="_blank">Datenschutzerklärung</a>');
    })
})
